import type { Flow } from "@flow";
import { QueueItem } from "../components/Queue/QueueItem";
import { getRolesFromSessionStorage } from "../utils/userHelper";
import {
  AttachmentsTab,
  ErrorsAttachmentsTab
} from "../views/attachments/AttachmentsTab";
import {
  ExternalDataTab,
  hasExternalData
} from "../views/external-data/ExternalDataTab";
import OverviewTab from "../views/overview";
import { createQueueDefinitionsCleanup } from "./cleanup-queue";
import { menu } from "./menu-structure";
import { createQueueDefinitionsFinland } from "./queue-definitions-finland";
import { createQueueDefinitionsNorway } from "./queue-definitions-norway";
import { createQueueDefinitionsSpain } from "./queue-definitions-spain";
import { createQueueDefinitionsSweden } from "./queue-definitions-sweden";
import { tasks } from "./tasks";

const roles = getRolesFromSessionStorage();

const CustomComponents = () => {
  return {
    case: {
      businessStatus: {
        map: (flow: Flow) => {
          return flow.data.businessStatus;
        }
      },
      tabs: [
        {
          id: "attachmentsTab",
          title: "Attachments",
          component: AttachmentsTab,
          hide: (flow: Flow) => flow.numAttachments <= 0
        },
        {
          id: "externalDataTab",
          title: "External data",
          component: ExternalDataTab,
          hide: (flow: Flow) => !hasExternalData(flow)
        },
        {
          id: "errorsTab",
          title: "Errors",
          component: ErrorsAttachmentsTab,
          hide: (flow: Flow) =>
            (flow.flowDefinitionId !== "cleanup" &&
              flow.flowDefinitionId !== "manual-cleanup") ||
            flow.numAttachments <= 0
        }
      ],
      tasks: tasks,
      caseSummary: {
        component: OverviewTab
      }
    },
    queue: {
      queueItem: QueueItem
    },
    menu: menu,
    // Menu items that fetch flow-processes.
    queueDefinition: {
      ...createQueueDefinitionsSpain(roles),
      ...createQueueDefinitionsSweden(roles),
      ...createQueueDefinitionsNorway(roles),
      ...createQueueDefinitionsFinland(roles),
      ...createQueueDefinitionsCleanup(roles)
    }
  };
};

export { CustomComponents };
